export default __webpack_public_path__ + "static/media/villa.75063523.jpg";